import styled from "styled-components";
import { PoolTable, NavigationBtnContainer } from '../../styles';
import { GhostBackButton } from "../../../../../../CommonComponents/CTA/Buttons";
import { PagePrimaryNumber, SectionSpacing, DataHeading, DataValue } from '../../../../../../CommonComponents/commonStyles';
import { Modal, Progress } from "antd";
import { ContainerDiv, RiskLabel } from "../../../../../../CommonComponents/ClipDivison/styles";

export const DollarWrapper = styled.div`
> div {
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
}
${PagePrimaryNumber}{
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: 1.5rem;
  letter-spacing: normal;
  color: ${props => props.theme.fontColors.textColor};
  padding-top: 5px;
  @media only screen and (max-width: 991px) {
    font-size: 1.25rem;
  }
}
@media only screen and (max-width: 991px) {
  padding-bottom: 30px;
  border-bottom: solid 1px ${props => props.theme.border.pill};  
  margin-top: 40px;
  > div {
    font-size: ${props => props.theme.fontSize.secondary};
  }
}
`;

export const CustomSectionSpacing = styled(SectionSpacing)`
  @media only screen and (max-width: 991px) {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
  }
`;

export const Table = styled(PoolTable)`
  &&& {
    //margin-top: 3rem;
    .ant-table .ant-table-thead {
      font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    }
    .ant-table .ant-table-header colgroup col:first-child,
    .ant-table .ant-table-body colgroup col:first-child {
      display: none;
    }
    .ant-table-thead > tr:first-child > th:first-child {
      display: none;
    }
    border-bottom: solid 1px ${props => props.theme.border.pill};
    @media only screen and (max-width: 767px) {
      &:first-of-type{
        margin-top: -20px;
      }
    }
  }  
  .ant-table .ant-table-tbody .ant-table-row{    
    td.pool-category-name {
      font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
      font-size: ${props => props.theme.fontSize.h4};
      font-weight: ${props => props.theme.fontWeight.normal};
      letter-spacing: ${props => props.theme.letterSpacing.normal};
      color: ${props => props.theme.fontColors.headingColor};
      padding: 30px 10px;
      @media only screen and (max-width: 767px) {
        font-size: ${props => props.theme.fontSize.h5};
        width: 100%;
        padding: 20px 0px 20px;
        margin-left: -15px;
      }
    }
  }
  .ant-table-row:nth-child(2n) {
    background-color: ${props =>
      props.theme.backgroundColor.tableAltRowDark}!important;
  }
  .ant-table-footer {
    background-color: #fff;
    border: none;
    padding: 30px 10px;    
    align-items: center;
    > div {
      width: 100%;
    }
    @media only screen and (max-width: 767px) {
      height: auto;
      padding: 20px 0px;
    }
  }
`;


export const ToNavigationBtnContainer = styled(NavigationBtnContainer)``;

export const ToTableFooter = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.heading};
  letter-spacing: ${props => props.theme.letterSpacing.point6}; 
`;

export const PoolName = styled.a`
font-family: ${props => props.theme.fontFamily.helveticaNeue};
cursor:pointer
text-decoration: underline;
color:#006778;
`;

export const Input = styled.input`
  border: solid 1px ${props => props.theme.border.filledTabsInactive};
  width: 100px;
  height: 40px;
  padding: 0px 10px;
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  color:${props => props.theme.fontColors.textColor};
  &:focus {
    border: 1px solid ${props => props.theme.colors.tabHead} !important;
    outline-color: ${props => props.theme.colors.tabHead} !important;
    outline-width: 1px !important;
  }
  @media only screen and (max-width: 991px) {
    width: 130px;
  }
  @media only screen and (min-width: 320px) and (max-width: 374px) {
    width: 95%;
  }
  ${props => {
    return (
      (props.disabled === true ) &&
      `background-color:${props.theme.backgroundColor.tableInputDisabled};
          border: none;
    `
    );
  }}
`;

export const TextTotal = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  color: ${props => props.theme.fontColors.textColor};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.11;
  letter-spacing: ${props => props.theme.letterSpacing.zero};
  padding-top: 3px;
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const ClearButton = styled.div`
  margin-left: auto;
  padding: 0 10px;
  @media only screen and (min-width: 992px) {
    width: 17%;
  }  
`;

export const TotalPercent = styled.div`
  flex-grow: 0 !important;
  text-align: right;
  font-size: ${props => props.theme.fontSize.primary};
  min-width: 110px;
  @media only screen and (max-width: 992px) {
    font-size: ${props => props.theme.fontSize.secondary};
  } 
`;

export const TotalSpan = styled.span`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  color: ${props => props.theme.fontColors.headingColor};
  background-color: #fff;  
  line-height: 20px;
`;

export const TotalFixedText = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.textColor};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: ${props => props.theme.letterSpacing.zero};  
`;

export const ErrorMessage = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  text-align: right;
  color: ${props => props.theme.fontColors.error};
  transform: translateY(40px);
  @media only screen and (max-width: 767px) {
    transform: translateY(25px);
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;

export const ButtonWrapper = styled.div`
  @media only screen and (max-width: 767px) {    
    width: 100%;
  }
`;

export const GhostBackButtonComponent = styled(GhostBackButton)`
  > div > span {
    font-family: ${props => props.theme.fontFamily.HelveticaNeue};
    font-size: ${props => props.theme.fontSize.heading};
    font-weight: 900;
    font-style: normal;
    font-stretch: condensed;
    line-height: 1.67;
    letter-spacing: 1.1px;
  }
`;

export const ResetAll = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  color: ${props => props.theme.fontColors.primary};
  letter-spacing: normal;
  font-size: ${props => props.theme.fontSize.primary};
  text-decoration: underline;
  flex-grow:0!important;  
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;  
  cursor: pointer;
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  } 
`;


export const DescriptionPara = styled.div`
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  font-size: ${props => props.theme.fontSize.primary};
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.43;
  letter-spacing: normal;
  color: ${props => props.theme.fontColors.textColor};
  margin: 0;
  padding-bottom: 29px;
  text-align: left;
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
`;
export const TableData = styled.p`
  font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
  font-size: ${props => props.theme.fontSize.primary};
  font-style: normal;
  font-stretch: normal;
  line-height: 1.71;
  letter-spacing: normal;
  text-align: left;
  line-height: 24px;
  margin: 0;
  // padding-bottom: 7px;
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
    line-height: 21px;
  }
`;
export const TableRow = styled.div`
  display: flex;
  ${({ justifyContent }) =>
    justifyContent &&
    `
  justify-content: space-between;
  `}
  ${({ margin }) =>
    margin &&
    `
    margin: 15px 0 40px;
  `}
  @media only screen and (max-width: 991.92px) {
    flex-direction: column;
  }
`;
export const ColWrapper = styled.div`
  font-size: 30px;
  text-align: center;
  color: ${props => props.theme.fontColors.headingColor};
  @media only screen and (max-width: 991.92px) {
    margin: 0 12px; 
  }
`;
export const SpacedRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${({ smallWidth }) =>
    smallWidth &&
    `
    width: 143px;
  `}
  ${({ largeWidth }) =>
    largeWidth &&
    `
    width: 207px;
  `}
  ${({ smJustifyStart }) => smJustifyStart && `
    @media only screen and (max-width: 991.92px) {
      justify-content: flex-start;
    }
  `}  
`;
export const Hr = styled.hr`
  margin: 20px 0 0 0;
  height: 50px;
  @media only screen and (max-width: 991.92px) {
    display: none;
  }
`;
export const ContentPara = styled.p`
  margin: 0;
  text-align: left;
  font-size: ${props => props.theme.fontSize.primary};
  >span {
    padding-right: 7px;
  }
  @media only screen and (max-width: 767px) {
    font-size: ${props => props.theme.fontSize.secondary};
  }
  ${({ lightText }) =>
    lightText &&
    `
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-weight: normal;
    color: ${props => props.theme.fontColors.textColor};
  `}
  ${({ boldText }) =>
    boldText &&
    `
    font-family: ${props => props.theme.fontFamily.helveticaNeueBold};
    //font-weight: bold;    
    color: ${props => props.theme.fontColors.headingColor};
  `}
  ${({ smallWidth }) =>
    smallWidth &&
    `
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-weight: normal;
    color: ${props => props.theme.fontColors.textColor};
    width: 165px; 
    @media only screen and (max-width: 991.92px) {
      width: 100%; 
    }
`}
${({ longWidth }) =>
    longWidth &&
    `
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-weight: normal;
    color: ${props => props.theme.fontColors.textColor};
    width: 515px; 
    @media only screen and (max-width: 991.92px) {
      width: 100%; 
    }
    @media (max-width: 576px) {
      line-height: 21px;
      font-size: ${props => props.theme.fontSize.primary};
    }
`}

`;
export const Ahref = styled.span`
a{ 
  font-family: ${props => props.theme.fontFamily.helveticaNeue};
  margin-left: 10px;
  font-size: ${props => props.theme.fontSize.primary};
  line-height: 1.5;
  letter-spacing: normal;
  color: ${props => props.theme.fontColors.primary};
  text-decoration: underline;
  &:hover {
    text-decoration: underline;
    color: ${props => props.theme.fontColors.primary};
  }
  @media (max-width: 576px) {
    line-height: 21px;
    font-size: ${props => props.theme.fontSize.secondary};
  }
}
`;
export const TableCol = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0 1.5rem;
  margin-bottom: 1.2rem;
  position: relative;
  text-align: left;
  ${({ colWidth }) =>
    colWidth &&
    ` 
    width:${colWidth}       
`}
  &:before{
    position: absolute;
    content:'';
    top: 0;
    bottom: 0;
    margin: auto;
    left: 0;
    width: 1px;
    height: 90%;
    background: rgba(151, 151, 151, 0.46);
  }
  &:first-child{
    padding: 0 1.5rem 0 0;
    &:before{
      display: none;
    }
  }
  &:last-child{
    padding: 0 0 0 1.5rem;
  }
  @media only screen and (max-width: 991.92px) {
    padding: 0 !important;
    width: 100%;
    &:before{
      display: none;
    }
    margin-bottom: 30px;
  }
`;

export const TableModal = styled(Modal)`
  &.ant-modal{
    max-width: 90%;
    @media only screen and (max-width: 991.92px) {    
      max-width: calc(100% - 44px);
      margin: 0 22px;      
      ${ContainerDiv}{
        margin: 0 15px;
      }
      ${RiskLabel}{
        margin: 6px 0;
      }
    }
    @media only screen and (max-width: 767px) {  {
      top: 20px; 
    }
  }
  .ant-modal-title {
    font-family: ${props => props.theme.fontFamily.berkeleyStdMedium};
    font-size: ${props => props.theme.fontSize.h4};
    color: ${props => props.theme.fontColors.headingColor};
    font-weight: ${props => props.theme.fontWeight.bold};
    text-align: center;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.17;
    letter-spacing: normal;
    @media(max-width: 576px){
      font-size: ${props => props.theme.fontSize.h5};
    }
  }
  .ant-modal-content {
    border-radius: 0px;
  }
  .ant-modal-header {
    padding: 30px 0 15px 0;
    border: none;
    border-radius: 0;
    @media only screen and (max-width: 991.92px) {
      padding: 30px 0 15px 0;
    }
  }

  .ant-modal-body {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    color: #505050;
    padding: 0 48px 0 33px;
    text-align: center;
    @media only screen and (max-width: 991.92px) {
      max-height: 377px;
      overflow: scroll;
      border-top: 1px solid ${props => props.theme.border.pill};
      border-bottom: 1px solid ${props => props.theme.border.pill};
      padding: 19px 15px 0px 0px;
      margin: 0 20px;
      &:after {
        background: linear-gradient(
            center bottom,
            #fff 0%,
            rgba(255, 255, 255, 0) 60%
          )
          repeat scroll 0 0 rgba(0, 0, 0, 0);
        bottom: 0;
        content: "";
        display: block;
        height: 30px;
        left: 0;
        pointer-events: none;
        position: fixed;
        width: 100%;
      }
    }
  }

  .ant-modal-footer {
    border-radius: 0;
    border: none;
    padding: 0px 0px 30px 0px;
    @media only screen and (max-width: 991.92px) {
      padding: 30px 0px 30px 0px;
    }
  }

  .ant-modal-footer > div {
    display: flex;
    flex-direction: column-reverse;
    align-items: center;
  }

  .ant-modal-footer > div > .ant-btn-primary {
    display: none;
  }

  .ant-modal-footer > div > .ant-btn-primary > span {
    color: #fff;
  }

  .ant-modal-footer > div > .ant-btn:first-child {
    border-radius: 0;
    font-family: ${props => props.theme.fontFamily.helveticaNeueCondensedBold};
    font-size:${props => props.theme.fontSize.primary};
    line-height: 1.67;
    letter-spacing: ${props => props.theme.letterSpacing.normal};
    width: ${props => props.theme.buttonWidth.primaryButton};
    height: 50px;
    color: ${props => props.theme.fontColors.primary};
    border: 1px solid ${props => props.theme.fontColors.primary};
    &:hover {
      border: 1px solid ${props => props.theme.fontColors.primary};
    }
    @media (max-width: 576px) {
      line-height: 21px;
      font-size: ${props => props.theme.fontSize.primary};
      padding: 10px 0;
    }
  }

  .ant-modal-footer > div > .ant-btn:first-child > span {
    color: ${props => props.theme.fontColors.color};
  }
`;


/** target allocation **/
export const ProgressUpdated = styled(Progress)`
  &&& {
    .ant-progress-circle-trail {
      stroke: #f0ab00 !important;
    }
  }
`;

export const ProgressLabel = styled(DataHeading)`
  margin-top: -3px;
  margin-left: 9px;
  @media (max-width: 576px) {
    margin-top: -5px;
  }
`;

export const ProgressValue = styled(DataValue)`
  @media (max-width: 576px) {
    margin-top: -3px;
  }
`;

export const ProgressCircle = styled.div`
  margin: 5px 18px 24px 0px;
`;

export const ProgressLabelContainer = styled.div`
  margin-top: 12px;
  @media (max-width: 576px) {
    margin-left: 18px;
  }
`;

export const CashSquare = styled.div`
  width: 10px;
  height: 10px;
  background-color: #0098db;
  margin-right: 8px;
  @media (min-width: 786px){
    margin-top: 5px;
  }
`;

export const StockSquare = styled.div`
  width: 10px;
  height: 10px;
  background-color: #f0ab00;
  margin-right: 8px;
  @media (min-width: 786px){
    margin-top: 5px;
  }
`;